import React from 'react';
import logoOjo from "../img/ojo.png";

const LogoOjo = () => (
    <img className='logo-ojo' src={logoOjo} alt="" height="80px"/>
);

export default LogoOjo;
